import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { saveProxy, validateProxyFormat } from '../../helpers/proxyStorage'
import Modal from '../Modal/Modal'
import { Header, Input } from '../ui'
import { Form, SaveButton, CancelButton, ButtonGroup } from './styles'

interface SaveProxyModalProps {
	isOpen: boolean
	onClose: () => void
	currentProxy: string
}

const SaveProxyModal: React.FC<SaveProxyModalProps> = ({
	isOpen,
	onClose,
	currentProxy
}) => {
	const [proxyName, setProxyName] = useState('')

	const handleSave = () => {
		if (!currentProxy) {
			toast.error('No proxy to save')
			return
		}

		if (!validateProxyFormat(currentProxy)) {
			toast.error('Invalid proxy format. Use: login:pass@ip:port')
			return
		}

		const savedProxy = saveProxy(currentProxy, proxyName.trim() || undefined)
		
		if (savedProxy) {
			toast.success(`Proxy "${savedProxy.name}" saved successfully`)
			setProxyName('')
			onClose()
		} else {
			toast.error('Failed to save proxy')
		}
	}

	const handleClose = () => {
		setProxyName('')
		onClose()
	}

	if (!isOpen) return null

	return (
		<Modal close={handleClose}>
			<Header>Save Current Proxy</Header>
			<Form>
				<Input
					id='proxy-name'
					placeholder='Enter a name for this proxy (optional)...'
					value={proxyName}
					onChange={(e) => setProxyName(e.target.value)}
				/>
				<div style={{ marginTop: '10px', fontSize: '14px', color: '#9ca3af' }}>
					Proxy: {currentProxy}
				</div>
				<ButtonGroup>
					<CancelButton type="button" onClick={handleClose}>Cancel</CancelButton>
					<SaveButton type="button" onClick={handleSave}>Save</SaveButton>
				</ButtonGroup>
			</Form>
		</Modal>
	)
}

export default SaveProxyModal